export default __webpack_public_path__ + "static/media/iconEllipsis.bd517b4b.svg";